export function getTimeDiffMs(t1: string, t2: string) {
    return Date.parse(t2) - Date.parse(t1);
}
